module.exports = __webpack_public_path__ + "1a79ebce0512a68bd71cacbc08b31af3.png";